<template>
  <div class="container">
    <hshead title="签名详情" bgcolor="#ffffff"></hshead>
    <div class="imgs">
      <img id="sImage" :src="signatureImgUrl" @load="onImgLoad" mode="aspectFit"/>
    </div>
    <div class="noSig" v-if="ifShowNoSig">【暂无签名】</div>
    <div class="signatureTime" v-if="!ifShowNoSig">签字日期：{{signatureTime}}</div>
    <div class="buttons">
      <!-- <el-upload
        action="/api/OssUpload/Images"
        list-type="picture"
        :on-success="uploadSuccess"
      > -->
      <input type="file" accept="image/*" @change="handleFileChange" ref="fileInput" style="display: none;">
      <!-- <el-button class="button greenButton" slot="trigger" type="primary">点击上传</el-button> -->
      <el-button class="button greenButton" @click="handleButtonClick">点击上传</el-button>
      <el-button class="button greenButton" @click="goToSignature">手写签名</el-button>
      <el-button class="button" @click="back">返回</el-button>
      <!-- </el-upload> -->
    </div>
  </div>
  
</template>
<script>
import axios from 'axios'
import hshead from "@/components/common/hshead";
import { getTaskOrderDetailSignature,sutmitOrderSignature } from "@/api/m/grapher";
	export default {
		data() {
			return {
				signatureImgUrl:'',
        signatureTime:'',
				orderId: 0,
				imgWidth: 0,
				imgHeight: 0,
				files: [],
				model:{
					orderId: '',
					signatureImgUrl: '',
				},
        listQuery:{
          orderId: ''
        },
				ifShowNoSig: false,
			}
		},
		created(){
			let self = this;
      // 获取网址中传递过来的参数id和值
			self.orderId = this.$route.query.id;
			self.init()
		},
		// onShow(){
		// 	let self = this;
		// 	self.init();
		// },
		methods: {
			init(){
				var self = this;
        self.listQuery.orderId = self.orderId;
        getTaskOrderDetailSignature(this.listQuery)
        .then(response => {
          console.info("response", response);
          const { code, msg, data } = response;
          if (code >= 0) {
            self.signatureImgUrl = data.order.signatureImgUrl;
            if(data.order.signatureTime!=null && data.order.signatureTime!='')
              self.signatureTime = self.formatChineseDate(data.order.signatureTime);
          }
					if(self.signatureImgUrl=='' || self.signatureImgUrl==null){
						self.ifShowNoSig = true;
					}
        })
        .catch(response => {
          Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
        });

			},
      formatChineseDate(dateString){
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
      },
			back(){
				// 返回上一页
        // this.$router.go(-1);
        location.href = "/Grapher/SignatureList"
			},
			goToSignature(){
				let self = this;
			  location.href = "/Grapher/Signature?id=" + self.orderId

			},
      handleFileChange(event) {
        this.load(true, "提交中...");
        const file = event.target.files[0];
        // 将input提交过来的图片上传到服务器
        let formData = new FormData();
        formData.append('file', file, 'signature.png');

        axios.post('/api/OssUpload/Images', formData).then(response => {
          // 处理响应
          console.log("处理响应："+JSON.stringify(response));

          if(response.data.code==0){
            // 上传成功后的操作
            let self = this;
            var param = self.model
            param.orderId = self.orderId;
            param.signatureImgUrl = response.data.data[0].path;
            // 提交签名
            sutmitOrderSignature(param).then(response => {
              console.info("+++sutmitOrderSignature response:", response);
              const { code, msg, data } = response;
              this.load(false);
              if(code >=0){
                self.$message({
                  message: "提交成功",
                  type: "success"
                });
              }else{
                self.$message({
                  message: "提交失败",
                  type: "fail"
                });
              }

              // 刷新当前页面
              location.reload();

            })
            .catch(response => {
              Toast.fail({ duration: 1000 * 5, message: `${response.msg}` });
            });
          }
        })
          .catch(error => {
            // 处理错误
            console.log("处理错误:"+error);
          });
      },
      handleButtonClick() {
        this.$refs.fileInput.click();
      },
      //创建一个onImgLoad()方法用来控制图片的展示最宽不能大于页面宽度的90%，高度不能大于页面的高度的70%，然后等比例缩放
      onImgLoad(event) {
        // 获取图片的原始宽度和高度
        const originalWidth = event.target.naturalWidth;
        const originalHeight = event.target.naturalHeight;

        // 获取页面的宽度和高度
        const pageWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const pageHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        // 计算最大的宽度和高度
        const maxWidth = pageWidth * 0.9;
        const maxHeight = pageHeight * 0.7;

        // 计算缩放比例
        const widthRatio = maxWidth / originalWidth;
        const heightRatio = maxHeight / originalHeight;
        const ratio = Math.min(widthRatio, heightRatio);

        // 计算新的宽度和高度
        const newWidth = originalWidth * ratio;
        const newHeight = originalHeight * ratio;

        // 设置图片的宽度和高度
        event.target.style.width = `${newWidth}px`;
        event.target.style.height = `${newHeight}px`;
      },
		},
    components: {
      hshead
    },
	}
</script>

<style lang="less" scoped>
.container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	overflow: hidden;

  .noSig{
    display: flex;
    color: #ff0000;
    height: 100px;
    width: 100%;
    font-size: 18px;
    align-items: center;
    justify-content: center;
  }
  .imgs{
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .buttons{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
  .button{
    margin-left: 2px;
    margin-right: 2px;
    font-size: 16px !important;
    width: 110px;
    /* height: 30px; */
    /* width: 100px; */
    /* margin-top: 10px; */
  }
  .greenButton{
    /* 按钮的颜色是绿色 */
    background-color: green;
    color: white;
    border: 1px solid green;
  }
  .signatureTime{
    margin-top: 5px;
    text-align: right;
    font-size: 12px;
    height: 20px;
    width: 95%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/grapher/signatureDetail.vue